import { get, post, put } from '@/security/Axios';

// Get the single company (array with 0 or 1 element)
export const fetchCompanies = () => get('/company');

// Create the only company (backend rejects if one exists with 409)
export const createCompany = (payload) => post('/company', payload);

// Update the company
export const updateCompany = (id, payload) => put(`/company/${id}`, payload);
